import { render, staticRenderFns } from "./SortableListAdder.vue?vue&type=template&id=fd5e8200&scoped=true&"
import script from "./SortableListAdder.vue?vue&type=script&lang=js&"
export * from "./SortableListAdder.vue?vue&type=script&lang=js&"
import style0 from "./SortableListAdder.vue?vue&type=style&index=0&id=fd5e8200&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5e8200",
  null
  
)

export default component.exports